var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.474 12c0 .814-.66 1.474-1.474 1.474M13.474 12c0-.814-.66-1.474-1.474-1.474M13.474 12H12m0 1.474c-.814 0-1.474-.66-1.474-1.474M12 13.474V12m-1.474 0c0-.814.66-1.474 1.474-1.474M10.526 12H12m0-1.474V12m11 0c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm-5.705 0a5.295 5.295 0 1 1-10.59 0 5.295 5.295 0 0 1 10.59 0Zm-1.19 0a4.105 4.105 0 1 1-8.21 0 4.105 4.105 0 0 1 8.21 0Zm-1.368 0a2.737 2.737 0 1 1-5.474 0 2.737 2.737 0 0 1 5.474 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJp);
export default __webpack_public_path__ + "static/media/jp.196cd6e945f7078cdac6cad6df2e84bd.svg";
export { ForwardRef as ReactComponent };